import { DataAssetDataType } from "./DataAsset.model";

export enum AccountLabel {
    CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS = "current_assets.cash_and_cash_equivalents",
    CURRENT_ASSETS_DEFERRED_EXPENSES = "current_assets.deferred_expenses",
    CURRENT_ASSETS_DERIVATIVES_AND_HEDGES = "current_assets.derivatives_and_hedges",
    CURRENT_ASSETS_NET_CONTRACTS_WITH_CUSTOMERS = "current_assets.net_contracts_with_customers",
    CURRENT_ASSETS_NET_INVENTORY = "current_assets.net_inventory",
    CURRENT_ASSETS_NET_RECEIVABLES = "current_assets.net_receivables",
    CURRENT_ASSETS_OTHER_CURRENT_ASSETS = "current_assets.other_current_assets",
    CURRENT_ASSETS_PREPAID_EXPENSES = "current_assets.prepaid_expenses",
    NONCURRENT_ASSETS_DEFERRED_EXPENSES = "noncurrent_assets.deferred_expenses",
    NONCURRENT_ASSETS_DERIVATIVES_AND_HEDGES = "noncurrent_assets.derivatives_and_hedges",
    NONCURRENT_ASSETS_INVENTORY = "noncurrent_assets.inventory",
    NONCURRENT_ASSETS_LONGTERM_INVESTMENTS_AND_RECEIVABLES = "noncurrent_assets.longterm_investments_and_receivables",
    NONCURRENT_ASSETS_NET_CONTRACTS_WITH_CUSTOMERS = "noncurrent_assets.net_contracts_with_customers",
    NONCURRENT_ASSETS_NET_INTANGIBLE_ASSETS_AND_GOODWILL = "noncurrent_assets.net_intangible_assets_and_goodwill",
    NONCURRENT_ASSETS_OTHER_ASSETS = "noncurrent_assets.other_assets",
    NONCURRENT_ASSETS_PREPAID_EXPENSES = "noncurrent_assets.prepaid_expenses",
    NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT = "noncurrent_assets.property_plant_and_equipment",
    NONCURRENT_ASSETS_RESTRICTED_CASH_AND_CASH_EQUIVALENTS = "noncurrent_assets.restricted_cash_and_cash_equivalents",
    CURRENT_LIABILITIES_ACCOUNTS_PAYABLE = "current_liabilities.accounts_payable",
    CURRENT_LIABILITIES_DEBT = "current_liabilities.debt",
    CURRENT_LIABILITIES_DEFERRED_REVENUE = "current_liabilities.deferred_revenue",
    CURRENT_LIABILITIES_DERIVATIVES_AND_HEDGES = "current_liabilities.derivatives_and_hedges",
    CURRENT_LIABILITIES_OTHER_LIABILITIES = "current_liabilities.other_liabilities",
    CURRENT_LIABILITIES_PROVISION_AND_ACCRUALS = "current_liabilities.provision_and_accruals",
    CURRENT_LIABILITIES_PROVISION_FOR_LOSSES_ON_CONTRACTS = "current_liabilities.provision_for_losses_on_contracts",
    CURRENT_LIABILITIES_PROVISION_FOR_REFUNDS = "current_liabilities.provision_for_refunds",
    NONCURRENT_LIABILITIES_ACCOUNTS_PAYABLE = "noncurrent_liabilities.accounts_payable",
    NONCURRENT_LIABILITIES_DEFERRED_REVENUE = "noncurrent_liabilities.deferred_revenue",
    NONCURRENT_LIABILITIES_DERIVATIVES_HEDGES = "noncurrent_liabilities.derivatives_hedges",
    NONCURRENT_LIABILITIES_LONGTERM_DEBT = "noncurrent_liabilities.longterm_debt",
    NONCURRENT_LIABILITIES_OTHER_LIABILITIES = "noncurrent_liabilities.other_liabilities",
    NONCURRENT_LIABILITIES_PROVISION_AND_ACCRUALS = "noncurrent_liabilities.provision_and_accruals",
    NONCURRENT_LIABILITIES_PROVISION_FOR_LOSSES_ON_CONTRACTS = "noncurrent_liabilities.provision_for_losses_on_contracts",
    NONCURRENT_LIABILITIES_PROVISION_FOR_REFUNDS = "noncurrent_liabilities.provision_for_refunds",
    EQUITY_PAID_IN_CAPITAL = "equity.paid_in_capital",
    EQUITY_RETAINED_EARNINGS = "equity.retained_earnings",
    REVENUES_COHORT = "revenues.cohort",
    REVENUES_NON_COHORT = "revenues.non_cohort",
    REVENUES_NON_COHORT_SEPARATE_COGS = "revenues.non_cohort_separate_cogs",
    REVENUES_NON_COHORT_NO_COGS = "revenues.non_cohort_no_cogs",
    REVENUES_NON_RECURRING = "revenues.non_recurring",
    EXPENSES_D_AND_A = "expenses.D_and_A",
    EXPENSES_GROSS_CASHFLOW_RELATED = "expenses.gross_cashflow_related",
    EXPENSES_NON_CASH_EXPENSES = "expenses.non_cash_expenses",
    EXPENSES_NON_RECURRING = "expenses.non_recurring",
    EXPENSES_OPEX_RELATED = "expenses.opex_related",
    EXPENSES_R_AND_D_RELATED = "expenses.r_and_d_related",
    EXPENSES_REVENUE_RELATED_FINANCIAL_PRINCIPAL_RECOUPMENT = "expenses.revenue_related.financial_principal_recoupment",
    EXPENSES_REVENUE_RELATED_INVENTORY_RECOUPMENT = "expenses.revenue_related.inventory_recoupment",
    EXPENSES_REVENUE_RELATED_INVENTORY_RECOUPMENT_NON_COHORT = "expenses.revenue_related.inventory_recoupment_non_cohort",
    EXPENSES_REVENUE_RELATED_NON_INVENTORY_COGS = "expenses.revenue_related.non_inventory_cogs",
    EXPENSES_REVENUE_RELATED_NON_INVENTORY_COGS_NON_COHORT = "expenses.revenue_related.non_inventory_cogs_non_cohort",
    INVESTMENTS_SALES_AND_MARKETING = "investments.sales_and_marketing",
    INVESTMENTS_EQUITY = "investments.equity",
    INVESTMENTS_INVENTORY = "investments.inventory",
    INVESTMENTS_LOAN = "investments.loan",
    INVESTMENTS_OTHER = "investments.other",
    BOOKINGS_COHORT = "bookings.cohort",
    BOOKINGS_NON_COHORT = "bookings.non_cohort",
    RECONCILED_NET_INCOME = "reconciled.net_income",
    FINANCING_DEBT_RAISED = "financing.debt_raised",
    FINANCING_DEBT_SERVICES_PRINCIPAL = "financing.debt_services.principal",
    FINANCING_DEBT_SERVICES_INTEREST = "financing.debt_services.interest",
    FINANCING_DEBT_SERVICES_FEES = "financing.debt_services.fees",
    FINANCING_EQUITY_RAISED = "financing.equity_raised",
    FINANCING_EQUITY_SERVICES_PRINCIPAL = "financing.equity_services.principal",
    FINANCING_EQUITY_SERVICES_INCOME = "financing.equity_services.income",
    GROSS_CASHFLOWS_COHORT = "gross_cashflows.cohort",
    GROSS_CASHFLOWS_NON_COHORT = "gross_cashflows.non_cohort",
    GROSS_CASHFLOWS_NON_RECURRING = "gross_cashflows.non_recurring",
    OTHER_INCOME_EXPENSE_NET_OTHER_INCOME = "Other_income/expense_net.Other_income",
    OTHER_INCOME_EXPENSE_NET_OTHER_INCOME_NEGATIVE = "Other_income/expense_net.Other_income_negative",
    OTHER_INCOME_EXPENSE_NET_OTHER_EXPENSE = "Other_income/expense_net.Other_expense",
    OTHER_INCOME_EXPENSE_NET_OTHER_EXPENSE_NEGATIVE = "Other_income/expense_net.Other_expense_negative",
    WORKING_CAPITAL_CYCLE = "working_capital_cycle",
    ASSETS = "assets",
    CURRENT_ASSETS = "current_assets",
    NONCURRENT_ASSETS = "noncurrent_assets",
    LIABILITIES = "liabilities",
    CURRENT_LIABILITIES = "current_liabilities",
    NONCURRENT_LIABILITIES = "noncurrent_liabilities",
    COGS = "cogs",
    COSTS = "costs",
    EBITDA = "ebitda",
    EBITDA_MARGIN = "ebitdaMargin",
    PRE_MARKETING_EBITDA_MARGIN = "pre_marketing_ebitda_margin",
    GROSS_MARGIN = "gross_margin",
    GROSS_PROFIT = "gross_profit",
    NET_INCOME = "net_income",
    NON_OPERATING_EXPENSES = "non_operating_expenses",
    OPERATING_EXPENSES = "operating_expenses",
    OPERATING_INCOME = "operating_income",
    OTHER_INCOME = "other_income",
    REVENUES = "revenues",
    NET_INCOME_MARGIN = "net_income_margin",
}

export enum PeriodKind {
    MONTHLY = "monthly",
    QUARTERLY = "quarterly",
    YEARLY = "yearly",
}

export interface Account {
    id: string;
    companyId: string;
    name: string;
    label: AccountLabel;
    lineagedValues?: {
        value: number;
        lineage: { dataAssetId: string };
        period: string;
    }[];
}

export const ACCOUNT_TAXONOMY = {
    [AccountLabel.REVENUES_COHORT]: {
        color: "#08BDBA",
        statementType: DataAssetDataType.INCOME_STATEMENT,
        name: "Cohort-able Revenue",
    },
    [AccountLabel.REVENUES_NON_COHORT]: {
        color: "#08BDBA",
        statementType: DataAssetDataType.INCOME_STATEMENT,
        name: "Non Cohort-able Revenue with Shared COGS",
    },
    [AccountLabel.REVENUES_NON_COHORT_SEPARATE_COGS]: {
        color: "#08BDBA",
        statementType: DataAssetDataType.INCOME_STATEMENT,
        name: "Non Cohort-able Revenue with Separate COGS",
    },
    [AccountLabel.REVENUES_NON_COHORT_NO_COGS]: {
        color: "#08BDBA",
        statementType: DataAssetDataType.INCOME_STATEMENT,
        name: "Non Cohort-able Revenue without COGS",
    },
    [AccountLabel.REVENUES_NON_RECURRING]: {
        color: "#08BDBA",
        statementType: DataAssetDataType.INCOME_STATEMENT,
        name: "Non Recurring Revenue",
    },

    [AccountLabel.EXPENSES_D_AND_A]: {
        color: "#DFBF03",
        statementType: DataAssetDataType.INCOME_STATEMENT,
        name: "Depreciation & Amortization",
    },
    [AccountLabel.EXPENSES_GROSS_CASHFLOW_RELATED]: {
        color: "#DFBF03",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.EXPENSES_NON_CASH_EXPENSES]: {
        color: "#DFBF03",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.EXPENSES_NON_RECURRING]: {
        color: "#DFBF03",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.EXPENSES_OPEX_RELATED]: {
        color: "#DFBF03",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.EXPENSES_R_AND_D_RELATED]: {
        color: "#DFBF03",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.EXPENSES_REVENUE_RELATED_FINANCIAL_PRINCIPAL_RECOUPMENT]: {
        color: "#DFBF03",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.EXPENSES_REVENUE_RELATED_INVENTORY_RECOUPMENT]: {
        color: "#DFBF03",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.EXPENSES_REVENUE_RELATED_INVENTORY_RECOUPMENT_NON_COHORT]: {
        color: "#DFBF03",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.EXPENSES_REVENUE_RELATED_NON_INVENTORY_COGS]: {
        color: "#DFBF03",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.EXPENSES_REVENUE_RELATED_NON_INVENTORY_COGS_NON_COHORT]: {
        color: "#DFBF03",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },

    [AccountLabel.INVESTMENTS_SALES_AND_MARKETING]: {
        color: "#4A66F4",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.INVESTMENTS_EQUITY]: {
        color: "#4A66F4",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.INVESTMENTS_INVENTORY]: {
        color: "#4A66F4",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.INVESTMENTS_LOAN]: {
        color: "#4A66F4",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.INVESTMENTS_OTHER]: {
        color: "#4A66F4",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },

    [AccountLabel.BOOKINGS_COHORT]: {
        color: "#AEC3FC",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.BOOKINGS_NON_COHORT]: {
        color: "#AEC3FC",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },

    [AccountLabel.FINANCING_DEBT_RAISED]: {
        color: "#DA348F",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.FINANCING_DEBT_SERVICES_PRINCIPAL]: {
        color: "#DA348F",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.FINANCING_DEBT_SERVICES_INTEREST]: {
        color: "#DA348F",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.FINANCING_DEBT_SERVICES_FEES]: {
        color: "#DA348F",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.FINANCING_EQUITY_RAISED]: {
        color: "#DA348F",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.FINANCING_EQUITY_SERVICES_PRINCIPAL]: {
        color: "#DA348F",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.FINANCING_EQUITY_SERVICES_INCOME]: {
        color: "#DA348F",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },

    [AccountLabel.GROSS_CASHFLOWS_COHORT]: {
        color: "#28A138",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.GROSS_CASHFLOWS_NON_COHORT]: {
        color: "#28A138",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.GROSS_CASHFLOWS_NON_RECURRING]: {
        color: "#28A138",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },

    [AccountLabel.OTHER_INCOME_EXPENSE_NET_OTHER_INCOME]: {
        color: "#007D79",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.OTHER_INCOME_EXPENSE_NET_OTHER_INCOME_NEGATIVE]: {
        color: "#007D79",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.OTHER_INCOME_EXPENSE_NET_OTHER_EXPENSE]: {
        color: "#007D79",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.OTHER_INCOME_EXPENSE_NET_OTHER_EXPENSE_NEGATIVE]: {
        color: "#007D79",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },

    [AccountLabel.RECONCILED_NET_INCOME]: {
        color: "#E8ECF2",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },

    [AccountLabel.CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS]: {
        color: "#10B981",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.CURRENT_ASSETS_DEFERRED_EXPENSES]: {
        color: "#10B981",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.CURRENT_ASSETS_DERIVATIVES_AND_HEDGES]: {
        color: "#10B981",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.CURRENT_ASSETS_NET_CONTRACTS_WITH_CUSTOMERS]: {
        color: "#10B981",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.CURRENT_ASSETS_NET_INVENTORY]: {
        color: "#10B981",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.CURRENT_ASSETS_NET_RECEIVABLES]: {
        color: "#10B981",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.CURRENT_ASSETS_OTHER_CURRENT_ASSETS]: {
        color: "#10B981",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.CURRENT_ASSETS_PREPAID_EXPENSES]: {
        color: "#10B981",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },

    [AccountLabel.NONCURRENT_ASSETS_DEFERRED_EXPENSES]: {
        color: "#059669",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_ASSETS_DERIVATIVES_AND_HEDGES]: {
        color: "#059669",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_ASSETS_INVENTORY]: {
        color: "#059669",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_ASSETS_LONGTERM_INVESTMENTS_AND_RECEIVABLES]: {
        color: "#059669",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_ASSETS_NET_CONTRACTS_WITH_CUSTOMERS]: {
        color: "#059669",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_ASSETS_NET_INTANGIBLE_ASSETS_AND_GOODWILL]: {
        color: "#059669",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_ASSETS_OTHER_ASSETS]: {
        color: "#059669",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_ASSETS_PREPAID_EXPENSES]: {
        color: "#059669",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT]: {
        color: "#059669",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_ASSETS_RESTRICTED_CASH_AND_CASH_EQUIVALENTS]: {
        color: "#059669",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },

    [AccountLabel.CURRENT_LIABILITIES_ACCOUNTS_PAYABLE]: {
        color: "#EF4444",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.CURRENT_LIABILITIES_DEBT]: {
        color: "#EF4444",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.CURRENT_LIABILITIES_DEFERRED_REVENUE]: {
        color: "#EF4444",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.CURRENT_LIABILITIES_DERIVATIVES_AND_HEDGES]: {
        color: "#EF4444",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.CURRENT_LIABILITIES_OTHER_LIABILITIES]: {
        color: "#EF4444",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.CURRENT_LIABILITIES_PROVISION_AND_ACCRUALS]: {
        color: "#EF4444",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.CURRENT_LIABILITIES_PROVISION_FOR_LOSSES_ON_CONTRACTS]: {
        color: "#EF4444",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.CURRENT_LIABILITIES_PROVISION_FOR_REFUNDS]: {
        color: "#EF4444",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },

    [AccountLabel.NONCURRENT_LIABILITIES_ACCOUNTS_PAYABLE]: {
        color: "#DC2626",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_LIABILITIES_DEFERRED_REVENUE]: {
        color: "#DC2626",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_LIABILITIES_DERIVATIVES_HEDGES]: {
        color: "#DC2626",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_LIABILITIES_LONGTERM_DEBT]: {
        color: "#DC2626",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_LIABILITIES_OTHER_LIABILITIES]: {
        color: "#DC2626",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_LIABILITIES_PROVISION_AND_ACCRUALS]: {
        color: "#DC2626",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_LIABILITIES_PROVISION_FOR_LOSSES_ON_CONTRACTS]: {
        color: "#DC2626",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_LIABILITIES_PROVISION_FOR_REFUNDS]: {
        color: "#DC2626",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },

    [AccountLabel.EQUITY_PAID_IN_CAPITAL]: {
        color: "#8B5CF6",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.EQUITY_RETAINED_EARNINGS]: {
        color: "#8B5CF6",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },

    [AccountLabel.ASSETS]: {
        color: "#10B981",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.CURRENT_ASSETS]: {
        color: "#10B981",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_ASSETS]: {
        color: "#059669",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.LIABILITIES]: {
        color: "#EF4444",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.CURRENT_LIABILITIES]: {
        color: "#EF4444",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
    [AccountLabel.NONCURRENT_LIABILITIES]: {
        color: "#DC2626",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },

    [AccountLabel.COGS]: {
        color: "#DFBF03",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.COSTS]: {
        color: "#DFBF03",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.EBITDA]: {
        color: "#28A138",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.EBITDA_MARGIN]: {
        color: "#28A138",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.PRE_MARKETING_EBITDA_MARGIN]: {
        color: "#28A138",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.GROSS_MARGIN]: {
        color: "#08BDBA",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.GROSS_PROFIT]: {
        color: "#08BDBA",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.NET_INCOME]: {
        color: "#E8ECF2",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.NON_OPERATING_EXPENSES]: {
        color: "#007D79",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.OPERATING_EXPENSES]: {
        color: "#DFBF03",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.OPERATING_INCOME]: {
        color: "#28A138",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.OTHER_INCOME]: {
        color: "#007D79",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },
    [AccountLabel.REVENUES]: {
        color: "#08BDBA",
        statementType: DataAssetDataType.INCOME_STATEMENT,
    },

    [AccountLabel.WORKING_CAPITAL_CYCLE]: {
        color: "#6B7280",
        statementType: DataAssetDataType.BALANCE_SHEET,
    },
} as const;
